import { property, subclass } from '@arcgis/core/core/accessorSupport/decorators';
import { messageBundle, tsx } from '@arcgis/core/widgets/support/widget';
import Widget from '@arcgis/core/widgets/Widget';
import { EAppTemplateType } from 'templates-common-library/baseClasses/CompatibilityChecker';

import t9nAppMessages from "../../t9n/App/App.json";
import "./InfoBadge/InfoBadge.scss";

@subclass('Landing.widgets.InfoBadge')
export default class InfoBadge extends Widget {
  @property()
  badge: string;

  @property()
  appType: EAppTemplateType;

  @property()
  uniqueId: string;

  @property()
  @messageBundle("dist/assets/t9n/App/App")
  appMessages: typeof t9nAppMessages;

  constructor(props) {
    super(props);
  }

  render() {
    const uniqueId = `${this.uniqueId}`;
    return (
      <calcite-tooltip-manager>
        <calcite-chip
          tabindex="0"
          scale="s"
          appearance="solid"
          id={uniqueId}
          class={this.classes("badge", `badge--${this.badge}`)}>
          {this.appMessages.appBadges[this.badge]}
        </calcite-chip>
        <calcite-tooltip reference-element={uniqueId} placement="top">
          {this._renderTooltip()}
        </calcite-tooltip>
      </calcite-tooltip-manager>
    )
  }

  private _renderTooltip(): string {
    const updatedTip = this.appMessages.appBadgeToolTips.Updated[this.appType];
    const genericUpdatedTip = this.appMessages.appBadgeToolTips.Updated.generic;
    return this.badge !== "Updated"
      ? this.appMessages.appBadgeToolTips[this.badge]
      : updatedTip != null ? updatedTip : genericUpdatedTip;
  }
}